<div oui-dialog-title>
  <div class="flex-horizontal flex-center width-100pc justify-space-between">
    <div class="headline-6">Aperçu de l'email</div>
  </div>
  <oui-button
    type="icon"
    color="secondary">
    <oui-icon mat-dialog-close>close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content class="content">
  @if (emailPreviewLoading() || emailPreviewHtml()) {
    <email-template-preview
      [loading]="emailPreviewLoading()"
      [html]="emailPreviewHtml()">
    </email-template-preview>
  } @else {
    <div class="body-1 color-on-surface-medium">L'aperçu de l'email n'est pas disponible.</div>
  }
</oui-dialog-content>
<oui-dialog-actions>
  <oui-button
    type="contained"
    oui-dialog-close>
    Fermer
  </oui-button>
</oui-dialog-actions>
